import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { CommentsSettings, defaultCommentsSettings, defaultGdprSettings } from '../../../../core/models';

@Component({
  selector: 'app-comments-settings',
  templateUrl: './comments-settings.component.html',
  styleUrls: ['./comments-settings.component.scss'],
  standalone: false
})
export class CommentsSettingsComponent implements OnInit, OnChanges {

  @Input() settings: CommentsSettings;
  @Output() saveSettings: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

  value: CommentsSettings = {
    ...defaultCommentsSettings
  };

  form: FormGroup = new FormGroup({
    shared: new FormControl<boolean>(false)
  });

  ngOnInit(): void {
    this.form.disable();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['settings']) {
      let disabled = this.form.disabled;
      this.settings = changes['settings'].currentValue;
      if (this.settings) {
        this.value = { ...defaultCommentsSettings, ...this.settings };
      }
      this.form.patchValue(this.value);
      if (disabled) {
        this.form.disable();
      }
    }
  }

  doEdit(): void {
    this.form.enable();
  }

  doCancel(): void {
    this.value = { ...defaultGdprSettings, ...this.settings };
    this.form.reset(this.value);
    this.form.disable();
  }

  doSave(): void {
    this.form.disable();
    this.saveSettings.emit(this.form);
  }
}
